import React, { memo, useContext, useState } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';
import TotalChange from './components/TotalChange';
import HighEnergy from './components/HighEnergy';
import CardBox from '../../../CardBox';
import { Space } from 'antd';
import { Button } from '@maxtropy/components';
import { DoubleRightOutlined } from '@ant-design/icons';
import SchedulingPolicy from './components/SchedulingPolicy';
import StrategyRecord from './components/StrategyRecord';
import { useNavigate } from 'react-router-dom';
import DemandStatisticsModal from './components/DemandStatisticsModal';
import HighEnergyModal from './components/HighEnergyModal';
import { ShareDataWrapperContext } from '@/pages/WgqAllMaps';

const RightBox = () => {
  const { isStandardSize, loadMap } = useContext(ShareDataWrapperContext);
  const [activeTransformerId, setActiveTransformerId] = useState<number>();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [highEnergyModalOpen, setHighEnergyModalOpen] = useState<boolean>(false);
  const navigate = useNavigate();

  // 大于2560分辨率且加载地图的情况
  const isCompactMode = !isStandardSize && loadMap;
  const isNoMapLayout = !loadMap;
  const isLargeNoMapLayout = !isStandardSize && isNoMapLayout;

  return (
    <CardBox
      title="负荷概览"
      className={classNames(
        styles.container,
        isCompactMode && styles.compactContainer,
        isLargeNoMapLayout && styles.container_no_map
      )}
      style={{
        height: isLargeNoMapLayout ? 'auto' : undefined,
      }}
      extraContent={
        <Space size={8}>
          <Button type="link" onClick={() => setModalOpen(true)}>
            需量
            <DoubleRightOutlined className="translationStyles" />
          </Button>
          <Button
            type="link"
            onClick={() => {
              window.open(`/power/system/configuration`, '_blank');
            }}
          >
            组态
            <DoubleRightOutlined className="translationStyles" />
          </Button>
        </Space>
      }
    >
      <TotalChange
        activeId={activeTransformerId}
        setActiveId={setActiveTransformerId}
        isCompactMode={isCompactMode}
        isNoMapLayout={isNoMapLayout}
        onCardClick={() => setHighEnergyModalOpen(true)}
      />
      {!isCompactMode && <HighEnergy activeId={activeTransformerId} />}
      {isCompactMode ? (
        <div className={styles.policyRecordWrapper}>
          <div className={styles.schedulingPolicyWrapper}>
            <SchedulingPolicy isCompactMode={isCompactMode} />
          </div>
          <div className={styles.strategyRecordWrapper}>
            <StrategyRecord isCompactMode={isCompactMode} />
          </div>
        </div>
      ) : (
        <SchedulingPolicy isCompactMode={isCompactMode} />
      )}
      <DemandStatisticsModal setModalOpen={setModalOpen} modalOpen={modalOpen} />
      <HighEnergyModal
        open={highEnergyModalOpen}
        onClose={() => setHighEnergyModalOpen(false)}
        activeId={activeTransformerId}
      />
    </CardBox>
  );
};

export default memo(RightBox);
